/**
 * @flow
 * Created by neo on 25.02.17.
 */
import {observer} from 'mobx-react';
import * as React from 'react';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import PageResult from '../Model/PageResult'

type Props = {
  page: PageResult<any>,
  onPage: (page: number, currentPage: number) => void,
};


@observer
export default class Pager extends React.Component<Props, any> {
  
  
  handlePrevious = () => {
    const { page: { current_page } } = this.props;
    this.handlePage((current_page - 1));
  };
  
  handleNext = () => {
    const { page: { current_page } } = this.props;
    this.handlePage((current_page + 1));
  };
  
  handlePage = (page: number) => {
    const { page: { current_page } } = this.props;
    this.props.onPage(page, current_page);
  };
  
  getPages = (page: number, lastPage: number) => {
    const LINKS_PER_STEP = 5;
    
    // Now calculate page links...
    let lastp1 = 1;
    let lastp2 = page;
    let page1 = 1;
    let page2 = page;
    let linksPerStep1 = LINKS_PER_STEP + 1;
    let linksPerStep2 = LINKS_PER_STEP + 1;
    let s1: Array<number> = [];
    let s2: Array<number> = [];
    let step = 1;
    let result: Array<number> = [];
    while (true) {
      if (linksPerStep1 >= linksPerStep2) {
        s1.push(page1);
        lastp1 = page1;
        page1 += step;
        linksPerStep1--;
      } else {
        s2 = [page2].concat(s2);
        lastp2 = page2;
        page2 -= step;
        linksPerStep2--;
      }
      if (linksPerStep2 === 0) {
        step *= 10;
        page1 += step - 1;         // Round UP to nearest multiple of $step
        page1 -= (page1 % step);
        page2 -= (page2 % step);   // Round DOWN to nearest multiple of $step
        linksPerStep1 = LINKS_PER_STEP;
        linksPerStep2 = LINKS_PER_STEP;
      }
      if (page1 > page2) {
        result = result.concat(s1).concat(s2);
        if ((lastp2 > page) || (page >= lastPage)) {
          return result;
        }
        lastp1 = page;
        lastp2 = lastPage;
        page1 = page + 1;
        page2 = lastPage;
        linksPerStep1 = LINKS_PER_STEP;
        linksPerStep2 = LINKS_PER_STEP + 1;
        s1 = [];
        s2 = [];
        step = 1;
      }
    }
  };
  
  render() {
    const { page: { current_page, last_page } } = this.props;
    const first = current_page === 1;
    const last = current_page === last_page;
    
    if(current_page >= 0 && last_page >= 0) {
      const pages = this.getPages(current_page, last_page);
      return (
        <Pagination style={{justifyContent: 'center'}}>
          <PaginationItem disabled={first}>
            <PaginationLink previous onClick={this.handlePrevious} href="javascript:void(0)" />
          </PaginationItem>
          {pages.map((p: number, i: number) => {
            return (
              <PaginationItem key={`${i}`} active={p === current_page}>
                <PaginationLink onClick={() => this.handlePage(p)} href="javascript:void(0)">
                  {`${p}`}
                </PaginationLink>
              </PaginationItem>
            )
          })}
          <PaginationItem disabled={last}>
            <PaginationLink next onClick={this.handleNext} href="javascript:void(0)" />
          </PaginationItem>
        </Pagination>
      );
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/App/Components/Pager.js